export function wave_bow({compId,shapeHeight,animationSpeed,flipAnimation}) {
  let flipA = 0;
  if(flipAnimation)flipA = -1.25;
  return `
  <pattern class="patternRepeat" id="pat_${compId}" patternUnits="userSpaceOnUse" height="${shapeHeight}" viewbox="0 0 960 120" x="50%" y="0" preserveAspectRatio="none" width="${shapeHeight*8}">
  <path d="M 960 60 L 960 120 L 0 120 L 0 60 L 960 60" fill="#8e8e8e">
    <animate attributeType="xml" attributeName="d"
    values="M 960,0 L 960,120 L 0,120 L 0,0 C 240,0 240,120 480,120 C 720,120 720,0 960,0 ;M 960,120 L 960,120 L 0,120 L 0,120 C 240,120 240,0 480,0 C 720,0 720,120 960,120 ;M 960,0 L 960,120 L 0,120 L 0,0 C 240,0 240,120 480,120 C 720,120 720,0 960,0 " keyTimes="0;0.50;1.00" keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
     dur="${5 * animationSpeed}s" repeatCount="indefinite"></animate>
  </path>
  <path class="ad-Path" d="M 960 60 L 960 120 L 0 120 L 0 60 L 960 60" fill="#ffffff">
    <animate attributeType="xml" attributeName="d" values="M 960,120 L 960,120 L 0,120 L 0,120 C 240,120 240,0 480,0 C 720,0 720,120 960,120 ;M 960,0 L 960,120 L 0,120 L 0,0 C 235,0 235,120 470,120 C 715,120 715,0 960,0 ;M 960,120 L 960,120 L 0,120 L 0,120 C 240,120 240,0 480,0 C 720,0 720,120 960,120 " keyTimes="0;0.50;1.00" keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${flipA * animationSpeed}s" dur="${5 * animationSpeed}s" repeatCount="indefinite"></animate>
  </path>
</pattern>
<mask id="mask_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" width="100%" height="${shapeHeight}" fill="url(#pat_${compId})"></rect>
</mask>
<mask class="flipped" id="mask_single_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" x="50%" width="1920" height="${shapeHeight}" fill="url(#single_${compId})"></rect>
</mask>
`;
}